import React, { useEffect } from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import MainRouter from "./navigation/Router";
import Footer from "./components/common/Footer";
import {
  autoLogout,
  constant,
  encryptData,
  inactivityTime,
  multiDecryption,
} from "./utils/utils";
import useSelector from "./store/selector";
import { useNavigate } from "react-router";
import { useState } from "react";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: "en",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
    react: {
      useSuspense: false,
    },
  });

export default function App() {
  const [callLogoutFun, setCallLogoutFun] = useState(false);
  const { getRecoilVal, setRecoilVal } = useSelector();
  const navigate = useNavigate();

  // window.onpopstate = (e) => { // Restrict for browser back button
  //   e.preventDefault();
  //   window.history.forward();
  // };

  useEffect(() => {
    async function autoNavigateToHomePage() {
      if (callLogoutFun) {
        let userData = getRecoilVal(constant.atomsName.USER_DETAIL);
        let data = await multiDecryption(userData);
        data?.screen === "pay"
          ? navigate(`/Pay/${data?.source}/${data?.anchor}/${data?.program}`)
          : navigate(`/${data?.source}/${data?.anchor}/${data?.program}`);
      }
    }
    autoNavigateToHomePage();
  }, [callLogoutFun]);

  window.onload = function () {
    inactivityTime(autoLogout, setCallLogoutFun);
  };

  window.onbeforeunload = function (e) {
    // clear localstorage on browser close
    window.onunload = function () {
      // window.localStorage.removeItem("userDetail");
      setRecoilVal(constant?.atomsName?.USER_DETAIL, null);
      setRecoilVal(constant?.atomsName?.GST_DETAILS, null);
      setRecoilVal(constant?.atomsName?.UDYAM_DETAILS, null);
      setRecoilVal(constant?.atomsName?.AADHAR_DETAILS, null);
    };
    return undefined;
  };

  return (
    <div>
      <MainRouter />
      <Footer />
    </div>
  );
}
